module.exports = __webpack_public_path__ + "static/img/bg-ar.12c608f9.png";